import { Controller, useFormContext } from 'react-hook-form';
import { RadioCardGroup, type RadioCardOption } from '../components/RadioCardGroup';
import type { SignupFormValues } from '../schema';

type Frequencia = SignupFormValues['frequenciaNetworking'];

const OPTIONS: ReadonlyArray<RadioCardOption<Frequencia>> = [
  { value: 'BAIXA', label: 'Baixa', description: 'Poucos eventos por ano' },
  { value: 'MEDIA', label: 'Média', description: 'De vez em quando' },
  { value: 'ALTA', label: 'Alta', description: 'Networking é rotina' },
];

export const Step11FrequenciaNetworking = () => {
  const {
    control,
    formState: { errors },
  } = useFormContext<SignupFormValues>();

  return (
    <Controller
      control={control}
      name="frequenciaNetworking"
      render={({ field }) => (
        <RadioCardGroup<Frequencia>
          label="Frequência de networking"
          value={field.value}
          onChange={field.onChange}
          options={OPTIONS}
          columns={3}
          errorMessage={errors.frequenciaNetworking?.message}
        />
      )}
    />
  );
};
